import React, { useEffect, useState } from "react";
import CouncilBanner from "../components/council/CouncilBanner";
import { fetchCouncilBanner, fetchCouncilMember } from "../api/CouncilApi";
import { dynamicFailed } from "../hooks/useToast";
import { IBannerData, ICouncilMemberData } from "../exports/interfaces";
import CouncilMember from "../components/council/CouncilMember";
import { useLoader } from "../context/LoaderContext";

const Council = () => {
  const { setLoading } = useLoader();
  const [councilBannerData, setCouncilBannerData] = useState<IBannerData[]>([]);
  const [councilMemberData, setCouncilMemberData] = useState<
    ICouncilMemberData[]
  >([]);
  useEffect(() => {
    setLoading(true);
    Promise.all([fetchCouncilBanner(), fetchCouncilMember()])
      .then(([councilData, councilMemberData]) => {
        setCouncilBannerData(councilData);
        setCouncilMemberData(councilMemberData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        dynamicFailed("Server Error");
        setTimeout(() => {
          setLoading(false); 
        }, 1000);
      });
  }, [setLoading]);
  return ( 
    <>
      <CouncilBanner councilBannerData={councilBannerData} />
      <CouncilMember councilMemberData={councilMemberData} />
    </>
  );
};

export default Council;
